import type { SurveySentimentSnapshot } from "@/types/sentiment";

interface AnswerLike { id?: number; questionId: number; textValue?: string | null; }
interface ResponseLike { answers: AnswerLike[]; }

export function computeAwaiting(
  questionId: number,
  responses: ResponseLike[],
  sentiment: SurveySentimentSnapshot | undefined
): number {
  const longTextAnswerIds = new Set<number>();
  for (const r of responses) for (const a of r.answers) {
    if (a.questionId === questionId && a.textValue != null && a.id != null) {
      longTextAnswerIds.add(a.id);
    }
  }
  if (longTextAnswerIds.size === 0) return 0;
  const accounted = new Set<number>();
  for (const a of sentiment?.answers ?? []) {
    if (a.questionId === questionId && (a.status === "completed" || a.status === "failed")) {
      accounted.add(a.answerId);
    }
  }
  let count = 0;
  for (const id of longTextAnswerIds) if (!accounted.has(id)) count++;
  return count;
}
